import { createContext, useContext } from 'react';
import { PackCopyDetailed, SpecDetail } from '../types';

// PackCopy state interface
export interface PackCopyState {
    packCopyDetailed: PackCopyDetailed;
    loadingState: 'loading' | 'loaded' | 'error';
    errorMessage: string | null;
}

export interface PackCopyHandlers {
    handleSpecDelete: (specName: string) => void;
    handleSpecUpdate: (specs: SpecDetail[]) => void;
    handleSpecCreation: (specs: SpecDetail[]) => void;
    handlePackCopyNameUpdate: (
        packCopyId: string,
        name: string,
    ) => Promise<void>;
    handlePackCopyNotesUpdate: (
        packCopyId: string,
        notes: string,
    ) => Promise<void>;
}

// Context including both state and setters
export interface PackCopyContextType {
    state: PackCopyState;
    handlers: PackCopyHandlers;
}

export const PackCopyContext = createContext<PackCopyContextType | null>(null);

export function usePackCopyContext() {
    const packCopyContext = useContext(PackCopyContext);

    if (packCopyContext === null) {
        throw new Error(
            'usePackCopyContext must be used with a PackCopyContext',
        );
    }

    return packCopyContext;
}
